/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

var SideNavSectionView = require('common/views/SideNavSectionView');
var switchToPrint = require('common/util/switchToPrint');
var GetTaskData = require('common/services/GetTaskData');
var showErrorMessage = require('common/util/showErrorMessage');

var Ladda = require('ladda');
var moment = require('moment');
var _ = require('underscore');

var SalesFinanceRenewalGeneralDetailsSectionView = require('./SalesFinanceRenewalGeneralDetailsSectionView');
var SalesFinanceContractsSectionsView = require('./SalesFinanceRenewalContractsSectionView');
var SalesFinanceRenewalAffirmationSectionView = require('./SalesFinanceRenewalAffirmationSectionView');
var SalesFinanceRenewalRequirementsSectionView = require('./SalesFinanceRenewalRequirementsSectionView');

var tmplSalesFinanceRenewalApplicationView = require('./SalesFinanceRenewalApplicationView.hbs');

var SubmitSalesFinanceRenewalApplication = require('../../services/SubmitSalesFinanceRenewalApplication');

module.exports = Marionette.LayoutView.extend({
  template: tmplSalesFinanceRenewalApplicationView,

  className: 'sales-finance-renewal-application-view m-b-md',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    salesFinanceRenewalApplicationContainer: '.sales-finance-renewal-application-container'
  },

  regions: {
    salesFinanceRenewalApplicationContainer: '@ui.salesFinanceRenewalApplicationContainer'
  },

  onBeforeShow: function() {
    var mode = this.options.mode;
    var isForPrinting = mode === 'print';
    var isExpandInternal = mode === 'int-expand';
    this.model.set('hideContactLink', this.options.isReadOnly);

    //Adding logic to hide this section if the application was submitted before #2411 was deployed to prod.
    var subDate = this.model.get('applicationDetails').submissionDate;
    var deployDate = moment('2024-09-05');
    var isProd = ENVIRONMENT === 'prod.int';
    var hideContactSection = !!subDate && subDate.isBefore(deployDate) && isProd;
    this.model.set('hideContactSection', hideContactSection);

    this.form = new SideNavSectionView({
      collection: new Backbone.Collection([
        {
          id: 'salesFinanceRenewalRequirements',
          title: 'Requirements',
          view: new SalesFinanceRenewalRequirementsSectionView({
            isReadOnly: this.options.isReadOnly
          })
        },
        {
          id: 'salesFinanceRenewalGeneralDetails',
          title: 'General Details',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new SalesFinanceRenewalGeneralDetailsSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'salesFinanceRenewalContractsSection',
          title: 'Contracts Section',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new SalesFinanceContractsSectionsView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },

        {
          id: 'salesFinanceRenewalAffirmation',
          title: 'Affirmation',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new SalesFinanceRenewalAffirmationSectionView({
            mode: this.options.mode,
            model: this.model
          })
        }
      ]),
      useNavigationButtons: !this.options.isReadOnly,
      expanded: isForPrinting || isExpandInternal,
      contentWidth: 'medium',
      buttons: [
        {
          buttonText: 'Save',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-save',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickSave.bind(this)
        }
      ]
    });

    if (
      this.options.isReadOnly &&
      !(this.options.mode === 'print' || this.options.mode === 'int' || this.options.mode === 'int-expand')
    ) {
      this.form.collection.remove(this.form.collection.get('salesFinanceRenewalAffirmation'));
    }

    this.showChildView('salesFinanceRenewalApplicationContainer', this.form);
  },

  onAttach: function() {
    if (this.options.mode === 'print') {
      switchToPrint(this.$el, '.input-view');
    }
  },

  onClickSave: function(e) {
    e.preventDefault();
    var self = this;
    var taskId = self.model.get('taskId');
    if (!_.isUndefined(taskId)) {
      GetTaskData(taskId).done(function(taskData) {
        if (taskData.state === 'COMPLETED') {
          showErrorMessage({
            errorCode: 'application.already.submitted',
            errorTitle: 'Application Already Submitted',
            errorMessage: 'This application has already been submitted.'
          });
        } else {
          self.saveApplication(e);
        }
      });
    } else {
      self.saveApplication(e);
    }
  },

  saveApplication: function(e) {
    var self = this;
    self.form.validateAll({ type: 'save' }).done(function() {
      var l = Ladda.create(e.currentTarget);
      l.start();
      var rawFormData = self.form.getFormData();
      var formData = {
        applicationId: self.model.get('applicationDetails').applicationId,
        generalDetails: rawFormData.salesFinanceRenewalGeneralDetails,
        contractsSection: rawFormData.salesFinanceRenewalContractsSection,
        affirmation: rawFormData.salesFinanceRenewalAffirmation
      };

      SubmitSalesFinanceRenewalApplication(formData)
        .done(function() {
          l.stop();
        })
        .fail(function() {
          l.stop();
        });
    });
  }
});
